module.exports = __webpack_public_path__ + "img/law4m-m@1.7482f8c2.jpg";